import { Component, HostListener } from '@angular/core';
import { GenericButtonComponent } from '../generic-button/generic-button.component';

@Component({
  selector: 'app-save-button',
  imports: [GenericButtonComponent],
  templateUrl: './save-button.component.html',
  styleUrl: './save-button.component.css',
})
export class SaveButtonComponent extends GenericButtonComponent {
  constructor() {
    super();
    this.textContent = 'Gem';
    this.color = 'accent';
    this.keyListener = 'Enter';
  }
}
